import styles from './statusImage.module.scss';
import { StatusCodeConstants } from "../../../constants/statusCode.constants";
import { StatusCode } from "../../../types/sharedTypes";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

type StatusImageProps = {
  statusCodeId: number;
  statusCode?: number;
}

export const StatusImage = ({ statusCodeId, statusCode }: StatusImageProps) => {

  const statusCodes = useSelector((state: RootState) => state.mainSlice.statusCodes);

  const getStatusCode = (): StatusCode | null => {
    const findStatus = statusCodes.find(item => item.id === statusCodeId);
    if (!!findStatus) {
      return findStatus
    } else {
      return null;
    }
  }

  const getStatusCodeEnum = (codeStatusCode: number): StatusCodeConstants => {
    if (codeStatusCode < 200) {
      return StatusCodeConstants.info
    } else if (codeStatusCode < 300) {
      return StatusCodeConstants.ok
    } else if (codeStatusCode < 400) {
      return StatusCodeConstants.redirect;
    } else {
      return StatusCodeConstants.error;
    }
  }

  const getStatusStyle = (): string => {
    const codeStatusCode = !!statusCode ? statusCode : getStatusCode()?.code;
    if (codeStatusCode) {
      const statusCodeEnum = getStatusCodeEnum(codeStatusCode)
      switch (statusCodeEnum) {
        case StatusCodeConstants.info:
          return styles.info
        case StatusCodeConstants.ok:
          return styles.ok
        case StatusCodeConstants.redirect:
          return styles.redirect
        default:
          return styles.error
      }
    } else {
      return "";
    }
  }

  return (
    <div className={`${styles.container} ${getStatusStyle()}`}></div>
  )
  ;
}